import Heading from 'components/Luxkit/Typography/Heading'
import React, { useMemo } from 'react'
import { rem } from 'polished'
import qs from 'qs'
import { TourV2TrendingDestination } from './TourV2TrendingLocationsList'
import styled from 'styled-components'
import TrendingDestinationsTile from 'home/components/TrendingDestinations/TrendingDestinationTile'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'

interface Props {
  locations: TourV2TrendingDestination[]
}

const TrendingDestinationsContainer = styled.div`
display: flex;
flex-direction: column;
margin-top: ${rem(40)};
margin-bottom: ${rem(24)};
gap: ${rem(32)};
`
const GridContainer = styled(CardCarousel)`
  > div > div {
    grid-template-rows: 1fr 1fr 1fr;

    ${mediaQueryUp.xs} {
      grid-template-rows: unset;
    }
  }
`

function TourV2TrendingDestinationsCarousel({ locations }:Props) {
  const trendingDestinations = useMemo(() => {
    return locations.map((location) => ({
      name: location.destinationName,
      imageId: location.imageId,
      destinationId: location.placeId,
      url: `/search/tours?${qs.stringify({
          destinationId: location.placeId,
          destinationName: location.destinationName,
        })}`,
    }))
  }, [locations])

  return <TrendingDestinationsContainer>
    <Heading variant="heading2">
      Immerse yourself in trending <i>destinations</i>
    </Heading>
    <GridContainer pageSize={6}>
      {
        trendingDestinations.map((trendingDestination, index) => {
          return (
            <TrendingDestinationsTile
              key={trendingDestination.name}
              trendingDestination={trendingDestination}
              fetchingMaxSavings={false}
              index={index}
            />
          )
        })
      }
    </GridContainer>
  </TrendingDestinationsContainer>
}

export default TourV2TrendingDestinationsCarousel
